export default __webpack_public_path__ + "static/media/OAR.1f093aff.svg";